import { types } from "../../../../../../../utils/constants";

import { MenuIcon } from "../../../../../../../assets/img/svg/MenuIcon";
import { SvgComponent } from "../../../../../../../components";

import { StyledImg } from "../../../../../../../components/common/Header/components/DropDownItem/DropDownItem.styled";
import { IconWrapper, ProxyName, StyledLinkBlog } from "./ProxyItem.styled";

const ProxyItem = ({ el: { iconSvg, iconUrl, type, providerUrl, title } }) => {
  return (
    <li>
      <StyledLinkBlog to={providerUrl} target="_blank">
        <IconWrapper>
          {iconSvg && <SvgComponent svgString={iconSvg} />}

          {iconUrl && !iconSvg && (
            <StyledImg src={iconUrl} alt="icon" width="24" height="24" />
          )}

          {!iconSvg && !iconUrl && (
            <MenuIcon tag={types.includes(type) ? type : "IPv4"} />
          )}
        </IconWrapper>

        <ProxyName>{title}</ProxyName>
      </StyledLinkBlog>
    </li>
  );
};

export default ProxyItem;
